<template>
  <div>
    <v-card
      style="background-color: transparent; border-radius: 15px"
      elevation="1"
    >
      <v-card-text>
        <v-container>
          <v-row
            dense
            class="mt-9"
            v-if="loading"
            alig="center"
            justify="center"
          >
            <v-progress-circular indeterminate></v-progress-circular>
          </v-row>
          <div v-else>
            <v-row dense class="mt-4">
              <v-col cols="12" class="d-flex align-center">
                <v-btn plain class="mr-2" @click="goBack">
                  <v-icon>mdi-chevron-left</v-icon>
                  <strong style="text-transform: capitalize">Voltar</strong>
                </v-btn>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col md="8">
                <div class="d-flex align-start justify-start flex-column">
                  <strong class="header">{{ course.title }}</strong>
                  <span class="regular mt-2">{{
                    course.description || "Selecione uma aula para começar"
                  }}</span>
                </div>
              </v-col>
              <v-col md="4" class="d-flex align-center justify-end">
                <v-img
                  contain
                  src="@/assets/images/connect/customer/modules.svg"
                  max-width="12vw"
                  max-height="12vh"
                />
              </v-col>
            </v-row>
          </div>
        </v-container>

        <v-container v-if="!loading && lessons.length > 0">
          <v-row dense class="d-flx align-start justify-start">
            <span style="font-size: 24px">Aulas</span>
          </v-row>
          <v-row dense style="margin-top: 5vh">
            <v-col
              v-for="(item, index) in lessons"
              :key="index"
              class="d-flex align-center justify-center pa-1"
              cols="12"
              md="4"
            >
              <CourseCard
                :moduleColor="'primary'"
                :item="item"
                @toCourse="goToLesson"
              />
            </v-col>
          </v-row>
        </v-container>

        <v-container v-if="!loading && lessons.length === 0">
          <v-row dense class="d-flx align-center justify-center">
            <span style="font-size: 24px"
              >Nenhuma aula disponível neste módulo 😢</span
            >
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import CourseCard from "@/components/connect/course/CourseCard.vue";
import pitchCustomerApi from "@/shared/pitchCustomerApi";

export default {
  name: "ModuleLessons",
  components: {
    CourseCard,
  },
  async created() {
    await this.loadModule();
  },
  data() {
    return {
      loading: true,
      course: {},
      lessons: [],
    };
  },
  methods: {
    async loadModule() {
      this.loading = true;
      await pitchCustomerApi
        .getCourseModule(this.$route.params.id)
        .then((response) => {
          this.course = response.data.module;
          this.lessons = response.data.module.classes || [];
          this.loading = false;
        })
        .catch(() => {
          this.$root.$emit("display-alert", {
            text: "Ocorreu um erro ao carregar o módulo",
            type: 2,
            timeout: 1500,
          });
          this.loading = false;
        });
    },
    goToLesson(item) {
      this.$router.push({
        path: "/connect/aluno/curso/" + item.id,
      });
    },
    goBack() {
      this.$router.push({ path: "/connect/aluno/curso" });
    },
  },
  watch: {
    "$route.params.id"() {
      this.loadModule();
    },
  },
};
</script>

<style scoped>
.header {
  font-family: "Poppins", "Sans-serif";
  font-size: 27.6px;
  font-weight: bold;
}
.regular {
  font-family: "Poppins", "Sans-serif";
  font-size: 16px;
}
</style>
